import api from "../axiosInstance";

// Get Config
export const getConfigAPI = async () => {
  try {
    const response = await api.get(
      process.env.REACT_APP_API_URL + "/api/v1/config"
    );
    return response.data;
  } catch (e) {
    console.log("Error getting config: " + e.message);
    throw e;
  }
};

// Update Config (Admin Only)
export const updateConfigAPI = async (payload) => {
  try {
    const response = await api.put(
      process.env.REACT_APP_API_URL + "/api/v1/config",
      payload
    );
    return response.data;
  } catch (e) {
    console.log("Error updating config: " + e.message);
    throw e;
  }
};
